import React, { useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import MainContent from './MainContent'
import { BadgeCheck, Building2, ClipboardList, FileText, Landmark, Ticket, TrendingUp, UserRound, UsersRound } from 'lucide-react'
import "./new-credit-dashboard.scss"
import { getKycVerificationByUserId, getKycVerificationByUserIdNew } from '../ActionCreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import { ROLE } from '../../../../../../utils/Constant'


export default function Main({ handleTabs, allDetail, admin, type }) {
    const [loader, setLoader] = useState(false)
    const [SidebarData, setSidebarData] = useState([
        { name: "Loan Particulars", icon: FileText, vals: "Positive", id: "loanParticular" },
        { name: "Business KYC", icon: Building2, vals: "Positive", id: "businessKyc" },
        { name: "Individual KYC", icon: UserRound, vals: "Positive", id: "individualKyc" },
        { name: "Management Profile", icon: UsersRound, vals: "Positive", id: "managementProfile" },
        { name: "Financial Analysis", icon: TrendingUp, vals: "Positive", id: "financialAnalysis" },
        { name: "Bank Statement", icon: Landmark, vals: "Positive", id: "bankStatement" },
        // { name: "GST Profile", icon: Ticket, vals: "Positive", id: "gstProfile" },
        { name: "Credit Assessment", icon: ClipboardList, vals: "Negative", id: "creditAssesment" },
        { name: "Recommendation", icon: BadgeCheck, vals: "Pending", id: "recomendations" },
    ])
    const [tab, setTab] = useState(SidebarData?.[0]?.id)
    const [individualKycData, setIndividualKycData] = useState({})

    const handleSection = (type) => {
        setTab(type);

        const element = document.getElementById(type);
        const container = document.getElementById("formCreditScrollContainer");

        if (element && container) {
            const offset = 20;

            const position = element.offsetTop - offset;

            container.scrollTo({
                top: position,
                behavior: "smooth",
            });
        }
    };


    const handleScroll = (e) => {
        const container = e.target;
        let currentSection = "";

        SidebarData.forEach((item) => {
            const section = document.getElementById(item.id);

            if (section) {
                const rect = section.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();

                // A section is "active" when its top has crossed
                // the upper 40% of the visible container area
                const threshold = containerRect.top + containerRect.height * 0.4;

                if (rect.top <= threshold) {
                    currentSection = item.id;
                }
            }
        });

        // Edge case: if the user has scrolled all the way to the bottom,
        // force-activate the last visible section
        const isAtBottom =
            container.scrollHeight - container.scrollTop <= container.clientHeight + 8;

        if (isAtBottom && SidebarData.length > 0) {
            currentSection = SidebarData[SidebarData.length - 1].id;
        }

        if (currentSection && currentSection !== tab) {
            setTab(currentSection);
        }
    };

    useEffect(() => {
        IndividualKycAPI()

        // if ((admin.rolelist != undefined &&
        //     admin.rolelist.indexOf(ROLE.CREDIT_ASSESSMENT_NEW) >= 0)) {
           

        //     setSidebarData([
        //         { name: "Loan Particulars", icon: FileText, vals: "Positive", id: "loanParticular" },
        //         { name: "Business KYC", icon: Building2, vals: "Positive", id: "businessKyc" },
        //         { name: "Individual KYC", icon: UserRound, vals: "Positive", id: "individualKyc" },
        //         // { name: "Management Profile", icon: UsersRound, vals: "Positive", id: "managementProfile" },
        //         { name: "Financial Analysis", icon: TrendingUp, vals: "Positive", id: "financialAnalysis" },
        //         { name: "Bank Statement", icon: Landmark, vals: "Positive", id: "bankStatement" },
        //         //   { name: "GST Profile", icon: Ticket, vals: "Positive", id: "gstProfile" },
        //         { name: "Credit Assessment", icon: ClipboardList, vals: "Negative", id: "creditAssesment" },
        //         { name: "Recommendation", icon: BadgeCheck, vals: "Pending", id: "recomendations" },
        //     ])
        // }else{
        //     setSidebarData([
        //         { name: "Loan Particulars", icon: FileText, vals: "Positive", id: "loanParticular" },
        //         { name: "Business KYC", icon: Building2, vals: "Positive", id: "businessKyc" },
        //         { name: "Individual KYC", icon: UserRound, vals: "Positive", id: "individualKyc" },
        //         // { name: "Management Profile", icon: UsersRound, vals: "Positive", id: "managementProfile" },
        //         { name: "Financial Analysis", icon: TrendingUp, vals: "Positive", id: "financialAnalysis" },
        //         { name: "Bank Statement", icon: Landmark, vals: "Positive", id: "bankStatement" },
               
        //     ])
        // }
    }, [])


    const [collapsed, setCollapsed] = useState(false);
    const [scorecardOpen, setScorecardOpen] = useState(false);

    const IndividualKycAPI = () => {
        setLoader(true)
        getKycVerificationByUserIdNew(allDetail?.userId, callback => {
            setLoader(false)
            setIndividualKycData(callback?.data ?? {})
            const rawStatus = callback?.data?.status ?? ""
            const normalize = (s) => {
                const lower = (s || "").toLowerCase()
                if (lower === "positive" || lower === "pass" || lower === "verified") return "Positive"
                if (lower === "negative" || lower === "fail" || lower === "failed") return "Negative"
                if (lower === "pending" || lower === "in progress") return "Pending"
                return "Positive" 
            }
            const normalizedStatus = normalize(rawStatus)

            setSidebarData((prev) =>
                prev.map((item) =>
                    item.id === "individualKyc"
                        ? { ...item, vals: normalizedStatus }
                        : item
                )
            );
        })
    }

    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='main-analysis-new-dashboard'>
                <Sidebar
                    SidebarData={SidebarData}
                    tab={tab}
                    handleSection={handleSection}
                    type={type}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                />
                <MainContent
                    tab={tab}
                    handleTabs={handleTabs}
                    individualKycData={individualKycData}
                    allDetail={allDetail} admin={admin}
                     type={type}
                     IndividualKycAPICall={IndividualKycAPI}
                     onScroll={handleScroll}
                     collapsed={collapsed}
                     scorecardOpen={scorecardOpen}
                     setScorecardOpen={setScorecardOpen}
                />

            </div>


        </>
    )
}
